import { SimpleForm, Button, useTranslate } from 'react-admin';
import { Update } from '@mui/icons-material';
import { Card, Drawer, Grid, Typography, Box } from '@mui/material';
import { useUpdateManyController } from '@/composables/useUpdateManyController';
import PropTypes from 'prop-types';
import ConfirmToolbar from '@/components/global/buttons/ConfirmToolbar';
import CustomCloseButton from '@/components/global/buttons/CustomCloseButton.jsx';
import ArrowLeftIcon from '@/assets/icons/arrow-left.svg?react';
import { BulkActionsContainer } from '@/components/global/buttons/bulkButtons.jsx';

export default function BulkDrawer({ title, children, available = true, transform = null, confirmSubmit = null, confirmMessage = '' }) {
    const { open, handleOpen, handleClose, handleSubmit, selectedIds } = useUpdateManyController({ transform });
    const translate = useTranslate();

    return (
        <>
            {available && (
                <BulkActionsContainer>
                    <Button onClick={handleOpen} startIcon={<Update />} label={title} />
                </BulkActionsContainer>
            )}
            <Drawer open={open} onClose={handleClose} anchor='right' sx={{ '& .MuiPaper-root': { overflowY: 'scroll' } }}>
                <Card className='custom-dialog-right custom-dialog-right--no-resizer'>
                    <Box className='custom-dialog-right__inner'>
                        <Box className='popup-wrapper popup-wrapper-top border-bottom'>
                            <Box className='popup-box popup-box--header'>
                                <Typography variant='h4' style={{ fontWeight: '400' }}>
                                    {translate('common.edit')}:<span style={{ display: 'block', fontWeight: '700' }}>{selectedIds.length}</span>
                                </Typography>
                                <Box>
                                    <CustomCloseButton onClose={handleClose} />
                                </Box>
                            </Box>
                        </Box>
                        <SimpleForm
                            mode='onBlur'
                            reValidateMode='onBlur'
                            toolbar={
                                <Box className='popup-wrapper popup-wrapper--footer'>
                                    <Button onClick={handleClose} color='secondary' startIcon={<ArrowLeftIcon />} label={translate('common.cancel')} />
                                    <ConfirmToolbar onSubmit={handleSubmit} shouldDisplay={confirmSubmit} message={confirmMessage} preventDefault />
                                </Box>
                            }
                        >
                            <Grid container>
                                <Grid item sm={12}>
                                    {children}
                                </Grid>
                            </Grid>
                        </SimpleForm>
                    </Box>
                </Card>
            </Drawer>
        </>
    );
}

BulkDrawer.propTypes = {
    title: PropTypes.string.isRequired,
    children: PropTypes.node,
    available: PropTypes.bool,
    transform: PropTypes.func,
    confirmSubmit: PropTypes.func,
    confirmMessage: PropTypes.string,
};
